module.exports = __webpack_public_path__ + "static/media/Roboto-BoldItalic.fb87f577.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Roboto-BoldItalic.woff2
// module id = 519
// module chunks = 0